module.exports = __webpack_public_path__ + "static/media/YF36_1.c7bf5dd2.jpg";